import { render, staticRenderFns } from "./lockroomEdit.vue?vue&type=template&id=38d9b37b&scoped=true&"
import script from "./lockroomEdit.vue?vue&type=script&lang=js&"
export * from "./lockroomEdit.vue?vue&type=script&lang=js&"
import style0 from "./lockroomEdit.vue?vue&type=style&index=0&id=38d9b37b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9b37b",
  null
  
)

export default component.exports